interface CrumbProps {
  label: string
  active: boolean
}

export const Crumb = ({ label, active }: CrumbProps) => (
  <li className={`breadcrumb-item text-secondary ${active && 'active fw-bold'}`}>{label}</li>
)
